import { characters } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const borderMap: Record<string, string> = {
  primary: "border-primary-300",
  secondary: "border-secondary-300",
  accent: "border-accent-400",
};

const tagMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  secondary: "bg-secondary-100 text-secondary-800",
  accent: "bg-accent-100 text-accent-900",
};

export default function Characters() {
  return (
    <section id="characters" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="Characters"
          title="人物档案：六个推动故事的人"
          desc="人物关系是这部作品最值得先了解的部分。下面六位角色分别承担核心、观察与推动功能，读懂他们，基本就读懂了故事为什么这样展开。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {characters.map((person) => (
            <article
              key={person.name}
              className="p-5 rounded-lg bg-background-50 border border-background-200 flex flex-col"
            >
              <div className="flex items-center gap-4">
                <span
                  className={`w-16 h-16 shrink-0 rounded-full overflow-hidden border-2 ${borderMap[person.accent]} bg-background-100`}
                >
                  <img
                    src={person.avatar}
                    alt={`${person.name} 人物形象`}
                    className="w-full h-full object-cover object-top"
                  />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{person.name}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{person.role}</p>
                  <p className="text-xs text-foreground-400 mt-0.5">年龄 · {person.age}</p>
                </div>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 flex-1">{person.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {person.tags.map((tag) => (
                  <span
                    key={tag}
                    className={`px-2.5 py-1 rounded-full text-xs whitespace-nowrap ${tagMap[person.accent]}`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}